export const enCopywritingFrameworks = {
	title: "Copywriting Frameworks",
	pageTitle: "Copywriting",
	description:
		"Frameworks define the strategic approach for each step of an outreach sequence. Default frameworks are pre-filled; you can add custom ones, edit, or disable them.",
	subTabs: {
		general: "General",
		frameworks: "Frameworks",
	},
	addFramework: "Add Framework",
	showDetails: "Show details",
	hideDetails: "Hide details",
	editFramework: "Edit Framework",
	createFramework: "Create Framework",
	deleteFramework: "Delete Framework",
	deleteConfirm: "Are you sure you want to delete this framework? This cannot be undone.",
	created: "Framework created successfully",
	updated: "Framework updated successfully",
	deleted: "Framework deleted successfully",
	toggled: "Framework toggled successfully",
	error: "An error occurred",
	default: "Default",
	custom: "Custom",
	enabled: "Enabled",
	disabled: "Disabled",
	applicableTo: "Applicable to",
	form: {
		name: "Name",
		namePlaceholder: "e.g. Observation",
		description: "Description",
		descriptionPlaceholder: "When to use this framework",
		structure: "Structure",
		structurePlaceholder: "How a message using this framework should be structured",
		applicableTo: "Applicable to",
		whenToUse: "When to use",
		whenToUsePlaceholder: "Guidance for the Framework Strategy Agent",
		whenNotToUse: "When not to use",
		whenNotToUsePlaceholder: "Guardrails — when this framework should be avoided",
	},
	messageType: {
		INTRO: "Intro",
		FOLLOW_UP: "Follow-up",
		BREAKUP: "Breakup",
	},
};
